import React from "react";
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';

export default class ComponentToPrint extends React.Component {
    render() {
        const attendanceDownloadData = this.props.attendanceDownloadData;
        const attendanceDownloadDataSearchValues = this.props.attendanceDownloadDataSearchValues;

        return (
            <div>
                <h3><center><u>Attendance Download</u></center></h3>
                <h5><center>From Date - {attendanceDownloadDataSearchValues.fromDate} </center></h5>
                <h5><center>To Date - {attendanceDownloadDataSearchValues.toDate} </center></h5>
                <div>&nbsp;</div>
                <div>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Location
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Feild
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Job
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Transaction Divisions
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Employee No
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Crop
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Attendance Date
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Full Half
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Work Type
                                </TableCell>
                                <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                    Quantity
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {attendanceDownloadData.map((row) => (
                                <TableRow key={row.fieldName}>
                                    <TableCell component="th" align="center" >
                                        {row.operationEntityName}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.fieldName}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.narration}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.collectionPointName}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.employeeCode}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.crop}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.createdDate.split('T')[0]}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.fullHalf}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.employeeTypeID}
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" >
                                        {row.totalAmount}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}


